import { Injectable } from '@angular/core';
import cytoscape from 'cytoscape';
import flowDesigner from './cytoscape/flow-designer';

@Injectable({
  providedIn: 'root',
})
export class FlowDesignerService {
  mousedown = false;

  constructor() {
    cytoscape.use(flowDesigner);
  }
}
